import { render, staticRenderFns } from "./project-template-edit.vue?vue&type=template&id=0fc84ad4"
import script from "./project-template-edit.vue?vue&type=script&lang=js"
export * from "./project-template-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports